import { useSelector } from 'react-redux';
import { mapSharedState } from 'app/infrastructure/redux/container-factory';

export const useSharedState = () => {
  return useSelector(mapSharedState);
};
